import * as React from 'react';
import { Props as LayoutProps } from './IntuitLayout';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { getToken } from './helpers/getToken';

export type Props = {
	Layout: any;
};

export const IntuitContainer = (props: Props) => {
	const [categoryTrie, setCategoryTrie] = useState(null);
	const [trieLoading, setTrieLoading] = useState(false);
	useEffect(() => {
		try {
			// getTrieData()
		} catch (e) {}
	}, []);

	const getTrieData = async () => {
		setTrieLoading(true);
		const token = await getToken();
		try {
			const url = 'http://localhost:6060/v1/custom/trie';
			const params = {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			};
			const response = await axios.get(url, params);
			setCategoryTrie(response.data);
		} catch (e) {
			console.log('e is', e);
		}
		setTrieLoading(false);
	};

	const handleInvalidationCache = async () => {
		setTrieLoading(true);
		const url = 'http://localhost:6060/v1/treadmill/invalidateRedis';
		setCategoryTrie(null);
		await axios.delete(url);
		await getTrieData();
	};
	const handleRepopulateCache = async () => {
		setTrieLoading(true);
		const url = 'http://localhost:6060/v1/treadmill/populateRedis';
		setCategoryTrie(null);
		await axios.post(url);
		await getTrieData();
	};

	const render = () => {
		const Layout = props.Layout;
		const outgoingProps: LayoutProps = {
			categoryTrie,
			handleRepopulateCache,
			handleInvalidationCache,
			trieLoading,
		};
		const returnValue = <Layout {...outgoingProps} />;
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
